import config from '@/config';

export async function onRequestComplete( response ) {
	let json;

	try {
		json = await response.json();
	}
	catch( e ) {
		console.error( e );
	}

	if ( !json || response.status >= 400 && response.status < 600 ) {

		// do we have an error message from the API?
		if( json && json.error ){
			json = json.error;
		}

		throw json || new Error( 'INVALID_RESPONSE' );
	}

	return json;
}

export function serialiseQueryParams( params ) {
	return Object.keys( params )
		.reduce( ( out, param ) => {
			return [ ...out, `${param}=${params[ param ]}` ];
		}, [] )
		.join( '&' );
}

export function getUrl( path, queryParams ) {
	return [
		config.endpoints[ process.env.NODE_ENV ],
		`api/${config.apiVersion}`,
		path,
		queryParams ? `?${serialiseQueryParams( queryParams )}` : '',
	].join( '/' );
}

export async function get( path, queryParams ) {
	const url = getUrl( path, queryParams );

	return fetch( url ).then( res => onRequestComplete( res ) );
}

export async function post( path, body ) {
	const url = getUrl( path );

	return fetch( url, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json;charset=utf-8' },
		body: JSON.stringify( body ),
	} ).then( res => onRequestComplete( res ) );
}
